module.exports = __webpack_public_path__ + "img/機能02_試験情報.0d00ace7.png";